import { parseTimestamp } from '@/util/zod/validators'
import { z } from 'zod'

export enum MatterArtifactVersionStatus {
  GENERATING = 'generating',
  COMPLETE = 'complete',
  ERROR = 'error',
  CANCELLED = 'cancelled',
}

export enum MatterArtifactFileExtension {
  MD = 'md',
}

export enum MatterArtifactVersionRevisionKind {
  INITIAL_DRAFT = 'initial_draft',
  MANUAL_EDIT = 'manual_edit',
  FULL_REVISION = 'full_revision',
  SELECTED_PASSAGE_EDIT = 'selected_passage_edit',
}

export enum MatterArtifactEditOperation {
  REPLACE = 'replace',
  INSERT_AFTER = 'insert_after',
}

export const MatterArtifactVersionReadSchema = z.object({
  id: z.string().uuid(),
  matter_artifact_id: z.string().uuid(),
  parent_matter_artifact_version_id: z.string().uuid().nullable(),
  created_by_user_id: z.string(),
  revision_kind: z.nativeEnum(MatterArtifactVersionRevisionKind),
  selected_passage_edit_operation: z.nativeEnum(MatterArtifactEditOperation).nullable(),
  is_current: z.boolean(),
  status: z.nativeEnum(MatterArtifactVersionStatus),
  file_extension: z.nativeEnum(MatterArtifactFileExtension),
  name: z.string().nullable(),
  summary: z.string().nullable(),
  created_at: z.preprocess((value, context) => parseTimestamp(value, context), z.number()),
  updated_at: z.preprocess((value, context) => parseTimestamp(value, context), z.number()),
})

export type MatterArtifactVersionRead = z.infer<typeof MatterArtifactVersionReadSchema>

export const MatterArtifactDraftReadSchema = z.object({
  artifact_version: MatterArtifactVersionReadSchema,
  conversation_id: z.string().uuid(),
})

export const MatterArtifactDraftListResponseSchema = z.array(MatterArtifactDraftReadSchema)

export type MatterArtifactDraftListResponse = z.infer<typeof MatterArtifactDraftListResponseSchema>

export const MatterArtifactVersionViewableUrlResponseSchema = z.object({
  matter_artifact_version_id: z.string().uuid(),
  viewable_url: z.string().min(1),
  expires_at: z.string(),
  content_type: z.string().min(1),
})

export type MatterArtifactVersionViewableUrlResponse = z.infer<typeof MatterArtifactVersionViewableUrlResponseSchema>
